import React, { useContext } from 'react';

import { PlexButtonProps } from '../views/shared/primitives/PlexButton';

export type ConfirmActionParams = {
  title: string;
  message: string | React.ReactNode;
  cancelButton?: PlexButtonProps;
  confirmButton?: PlexButtonProps;
};

type PlexContextType = {
  confirmAction: (args: ConfirmActionParams) => void;
};

export const PlexContext = React.createContext<PlexContextType>({
  confirmAction: (args: ConfirmActionParams): void => {
    console.error(
      'Custom plex error: "confirmAction" is not implemented, make sure you used PlexContext.Provider in the root component!'
    );
  },
});

export const useConfirmAction = (): PlexContextType['confirmAction'] => {
  const context = useContext(PlexContext);
  return context.confirmAction;
};
